import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../reducers';
import { UsuarioExpiracionClave } from '../session/store/session';
import { PostponePassExpirationRequested } from '../session/store/session.actions';
import { sessionPostponePassExpirationReady, sessionUsuarioExpiracionClave } from '../session/store/session.selectors';
import { showExpiracionClaveAnimation } from './expiracion-clave.animations';

@Component({
	selector: 'expiracion-clave',
	templateUrl: './expiracion-clave.component.html',
	styleUrls: ['./expiracion-clave.component.scss'],
	animations: [ showExpiracionClaveAnimation ]
})
export class ExpiracionClaveComponent {

	expiracionClave$: Observable<UsuarioExpiracionClave>;
	ready$: Observable<boolean>;

	constructor( private store: Store<AppState> ) {
		this.expiracionClave$ = this.store.select( sessionUsuarioExpiracionClave );
		this.ready$ = this.store.select( sessionPostponePassExpirationReady );
	}

	private onModificarClave() {
	}

	private onRecordarMasTarde() {
		this.store.dispatch( new PostponePassExpirationRequested() );
	}

}
